import { render } from "./tw-radio.vue?vue&type=template&id=d2ae6150"
import script from "./tw-radio.vue?vue&type=script&lang=js"
export * from "./tw-radio.vue?vue&type=script&lang=js"
script.render = render

export default script